<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2026-02-02 19:51 -->
<!-- Description:  -->
<template>
  <div>

    <table class="table table-bordered">
      <thead>
        <tr>
          <th v-for="(dayOfWeek, i1) in weekDays" :key="i1">{{ dayOfWeek }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td v-for="(dayOfWeek, i2) in weekDays" :key="i2" class="p-0 text-center">
            <app-checkbox v-model="dayStates[i2]"></app-checkbox>
          </td>
        </tr>
        <tr>
          <th colspan="7" class="text-center">Primer Turno</th>
        </tr>
        <tr>
          <td v-for="(dayOfWeek, i3) in weekDays" :key="i3" class="p-0">
            <input type="time" class="w-100 border-0 py-2 text-center"
              :disabled="!dayStates[i3]" @change="handleChangeTime($event, `${i3}_1`)"
              :ref="`T${i3}_1`" data-model="1">
          </td>
        </tr>
        <tr>
          <td v-for="(dayOfWeek, i4) in weekDays" :key="i4" class="p-0">
            <input type="time" class="w-100 border-0 py-2 text-center"
              :disabled="!dayStates[i4]" @change="handleChangeTime($event, `${i4}_2`)"
              :ref="`T${i4}_2`" data-model="1">
          </td>
        </tr>
        <tr>
          <th colspan="7" class="text-center">Segundo Turno</th>
        </tr>
        <tr>
          <td v-for="(dayOfWeek, i5) in weekDays" :key="i5" class="p-0">
            <input type="time" class="w-100 border-0 py-2 text-center"
              :disabled="!dayStates[i5]" @change="handleChangeTime($event, `${i5}_3`)"
              :ref="`T${i5}_3`" data-model="1">
          </td>
        </tr>
        <tr>
          <td v-for="(dayOfWeek, i6) in weekDays" :key="i6" class="p-0">
            <input type="time" class="w-100 border-0 py-2 text-center"
              :disabled="!dayStates[i6]" @change="handleChangeTime($event, `${i6}_4`)"
              :ref="`T${i6}_4`" data-model="1">
          </td>
        </tr>
      </tbody>
    </table>

    <div class="mb-3">
      <button class="btn btn-secondary ml-1" @click="clear()">Limpiar</button>
      <button class="btn btn-primary ml-1" @click="save()">Guardar</button>
    </div>

    <app-alert class="alert-success" :show="saved" @update:show="saved = $event">
      Guardado Correctamente
    </app-alert>
  </div>
</template>
<script>
import {AdminService} from "src/lt/admin-module/AdminService.js";


const rules = {}
export default {
  name: "HoraryForm",
  components: {
    //
  },

  // directives

  props: {
    disabled: { default: false },
    content: {
      default: () => ({}),
    },
    employee_id: {
      require: true,
    }
  },

  data: () => ({
    weekDays: ["Domingo", "Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado"],
    sending: false,
    dayStates: [false, false, false, false, false, false, false],
    reg: {},
    saved: false,
  }),

  computed: {
    errors() { return false; }
  },

  // watch: {},

  mounted() {
    if(this.content && this.content.id) {
      this.reg = this.content;
      for(let it in this.reg.times) {
        let row = this.reg.times[it];
        let [order1, order2] = row.group == 1 ? [1,2] : [3,4];
        this.$refs[`T${row.day_of_week}_${order1}`][0].value = row.ini_time;
        this.$refs[`T${row.day_of_week}_${order2}`][0].value = row.end_time;
        this.dayStates = [
          this.reg.d0,
          this.reg.d1,
          this.reg.d2,
          this.reg.d3,
          this.reg.d4,
          this.reg.d5,
          this.reg.d6,
        ];
      }
    }
  },

  methods: {
    async save() { 
      this.saved = false;
      this.sending = true;
      let reg = this.generateValue();
      let res = await AdminService.saveEmployeeSchedule(reg);
      this.sending = false;
      this.saved = true;
      this.$emit("saved", res);
    },
    reset() { this.sending =false; },
    setValue() {},
    handleChangeTime(ev, key) {
      let [order, group] = key.split('_');
      for(let it in this.weekDays) {
        let result = this.$refs[`T${it}_${group}`];
        let elInput = result.length > 0 ? result[0] : null;
        if (!elInput.value && this.dayStates[it]) {
          elInput.value = ev.target.value;
        }
      }
    },
    clear() {
      for(let it in this.$refs) {
        let firstEl = this.$refs[it][0];
        firstEl.value = null;
      }
    },
    getTimesFromTurn(group) {
      let times = [];
      let [order1, order2] = group == 1 ? [1,2] : [3,4];
      for(let i=0; i<7; i++) {
        times.push({
          day_of_week: i,
          ini_time: this.$refs[`T${i}_${order1}`][0].value || null,
          end_time: this.$refs[`T${i}_${order2}`][0].value || null,
          group: group,
        });
      }
      return times;
    },
    generateValue() {
      let times = [];
      times = this.getTimesFromTurn(1)
      times = [...times , ...this.getTimesFromTurn(2)]
      let reg = {
        ...this.reg,
        employee_id: this.employee_id,
        d0: this.dayStates[0],
        d1: this.dayStates[1],
        d2: this.dayStates[2],
        d3: this.dayStates[3],
        d4: this.dayStates[4],
        d5: this.dayStates[5],
        d6: this.dayStates[6],
        ini_schedule: '2000-01-01',
        end_schedule: '2050-01-01',
        times,
      };
      return reg;
    },
  }
};
</script>
<style scoped></style>

